import routes from "@/routes.js"
import { shareInAppTypes } from "@/constants/shareInApp.js"

export const isValid = function (url) {
  return Boolean(url && url.match(/^(http[s]?:\/\/|mailto:)[^ "]+$/i))
}

export const getParamFromUrl = function (url, paramName) {
  if (!url) {
    return null
  }

  const urlParams = new URL(url)
  return urlParams.searchParams.get(paramName)
}

export const getYoutubeVideoEmbedUrl = function (url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  const youtubeId = match && match[7].length === 11 ? match[7] : null

  if (!youtubeId) {
    return null
  }

  return `https://www.youtube.com/embed/${youtubeId}`
}

export const getVimeoVideoEmbedUrl = function (url) {
  const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
  const match = url.match(regExp)
  const vimeoId = match && match[5] ? match[5] : null

  if (!vimeoId) {
    return null
  }

  return `https://player.vimeo.com/video/${vimeoId}`
}

export const getRouterRouteFromDeepLink = function (deeplink) {
  if (!deeplink) {
    return null
  }

  const deeplinkSplitByParams = deeplink.split("?")

  const queryObject = deeplinkSplitByParams.length > 1 ? Object.fromEntries(new URLSearchParams(deeplinkSplitByParams[1])) : undefined

  const pathPartsWithoutQuery = deeplinkSplitByParams[0]
  const pathParts = pathPartsWithoutQuery.split("/")
  const mainPath = pathParts[1]
  const param1 = pathParts[2]

  switch (mainPath) {
    case "profile":
      if (pathParts[4]) {
        return {
          name: routes.PROFILE_BADGE,
          params: {
            id: Number(param1),
            badgeKey: pathParts[4]
          }
        }
      }
      return {
        name: routes.PROFILE
      }
    case "groups":
      return {
        name: routes.GROUPS,
        params: {
          groupId: param1
        }
      }
    case "posts": {
      const commentId = pathParts[4]
      if (commentId) {
        return {
          name: routes.COMMENT,
          params: {
            postId: param1,
            commentId: commentId
          }
        }
      }

      return {
        name: routes.POST,
        params: {
          postId: param1
        }
      }
    }
    case "messages":
      return {
        name: routes.MESSAGES,
        params: {
          id: param1
        }
      }
    case "archive":
      return {
        name: routes.FOLDER,
        params: param1 ? { folderId: param1 } : undefined
      }
    case "articles":
      return {
        name: routes.ARTICLE,
        params: {
          articleId: param1
        }
      }
    case "events":
      return {
        name: param1 ? routes.EVENT : routes.EVENTS,
        params: param1 ? { id: param1 } : undefined
      }
    case "hashtags":
      return {
        name: routes.HASHTAGS,
        params: {
          hashtagId: param1.replace("#", "")
        }
      }
    case "users":
    case "friends":
      return {
        name: routes.PROFILE,
        params: {
          id: param1
        }
      }
    case "search":
      return {
        path: param1 ? `/search/${param1}` : "/search",
        query: queryObject?.query ? { query: queryObject.query } : undefined
      }
    case "members":
      return {
        name: routes.MEMBER_DIRECTORY,
        query: queryObject
      }
    case "landingsection":
      return {
        name: routes.ROOT
      }
    case "onefeed":
      return {
        name: routes.GROUPS
      }
    case "live":
      return {
        name: routes.LIVE,
        params: param1 ? { id: param1 } : undefined
      }
    case "purchases":
      return {
        name: routes.PAYWALL
      }
    case "walkthrough":
      return {
        name: routes.WALKTHROUGH
      }
    case "course":
      return {
        name: routes.COURSE,
        params: {
          courseId: Number(param1)
        }
      }
    case "courses":
      return {
        name: routes.COURSES,
        params: {
          tab: param1
        }
      }
    case "settings":
      return {
        name: routes.PROFILE_SETTINGS
      }
  }
  return null
}

export const getDeepLinkFromItem = function ({ item, itemType }) {
  if (!item || !itemType) {
    return null
  }

  switch (itemType) {
    case shareInAppTypes.GROUP:
      return `/groups/${item.key}`
    case shareInAppTypes.EVENT:
      return `/events/${item.id}`
  }
  return null
}

export const goTo = function (url) {
  window.location.assign(url)
}
